import { render } from "./TreinadorDetalhes.vue?vue&type=template&id=70a411df"
import script from "./TreinadorDetalhes.vue?vue&type=script&lang=js"
export * from "./TreinadorDetalhes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__